/**
 * 返回一些系统设备信息
 */

/**
 * 是否是Mac系统
 */
export const isMacOS = /Mac OS X/.test(window.navigator.userAgent);
